import React from 'react';
import { useState, useContext, useEffect } from 'react';
import { SCOPES } from '../../../../config/permissions-map';
import * as Utilities from '../../../../Components/Utils/Utils';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { PageTitle } from '../../../../../_metronic/layout/core';
import PermissionsGate from '../../../../api/PermissionsGate';
import { Unauthorized } from '../../../Global/unauthorized';
import Mantenimiento from './Mantenimiento';
import $ from 'jquery';



function MapaVistaGeneral_mantenimiento({ title }) {

    let ueByNotification = window.sessionStorage.getItem("ContratoPorNotificacionUE");
    let unidadEco = null;
    if (ueByNotification) unidadEco = Utilities.getListUnidadesEconomicas().list.find((element => element.value == ueByNotification));

    const [unidadEconomica, setUnidadEconomica] = useState(unidadEco ? unidadEco : Utilities.getListUnidadesEconomicas().list[0]);
    let unidadesEconomicasList = Utilities.getListUnidadesEconomicas();

    const getOptionUnidadEconomica = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }
    const onChangeUnidadEconomica = (inputValue) => {
        setUnidadEconomica(inputValue);
    }


    function handleChangeobjetoAlquiler(event) {
        if (event.key === 'Enter') $(`#${event.target.value}`).click();
    }



    const animatedComponents = makeAnimated();

    setTimeout(() => { sessionStorage.removeItem('ContratoPorNotificacionUE'); }, 1000);

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.MAPA_CALOR_MANTENIMIENTO]} >
                <>
                    <PageTitle>{title}</PageTitle>
                    <div className="card my-5">
                        <div className="card-header border-0 pt-6 row g-3 flex-wrap d-flex flex-row" style={{ zIndex: 10 }}>
                            <div className="col-12 col-sm-4" >
                                <div className="fw-bold fs-7 text-gray-600 mb-1">Mall:</div>
                                <Select
                                    classNamePrefix='filter'
                                    components={animatedComponents}
                                    defaultValue={unidadEco ? getOptionUnidadEconomica(unidadEco.value) : getOptionUnidadEconomica(unidadesEconomicasList.defaultId)}
                                    isMulti={false}
                                    closeMenuOnSelect={true}
                                    options={unidadesEconomicasList.list}
                                    onChange={(onChangeUnidadEconomica)}
                                />
                            </div>

                            <div className="col-12 col-sm-4" >
                                <div className="fw-bold fs-7 text-gray-600 mb-1">Ubicar Objeto en Alquiler:</div>
                                <input type="text" name="name" className="form-control"
                                    onKeyDown={handleChangeobjetoAlquiler} />
                            </div>
                        </div>

                        <div className="card-body tab-content pt-0">
                            <Mantenimiento unidadEconomicaId={unidadEconomica.value} unidadEconomicaName={unidadEconomica.label}></Mantenimiento>
                        </div>
                    </div>
                </>
            </PermissionsGate>
        </>
    )
}

export default MapaVistaGeneral_mantenimiento
